const options = {
  excludeColorDepth: true,
  excludeScreenResolution: true,
  excludeSessionStorage: true,
  excludeIndexedDB: true,
  excludeAddBehavior: true,
  excludeOpenDatabase: true,
  excludeCpuClass: true,
  excludePlatform: true,
  excludeDoNotTrack: true,
  excludeCanvas: true,
  excludeWebGL: true,
  excludeAdBlock: true,
  excludeFlashFonts: true,
  excludePlugins: true,
  excludeTouchSupport: true,
  excludeJsFonts: true,
};

const isReady = () => {
  return !!window.Fingerprint2;
};

const generate = () => {
  return new Promise((resolve) => {
    const fp = new window.Fingerprint2(options);
    fp.get((fingerprint) => {
      resolve(fingerprint);
    });
  });
};

export default {
  isReady,
  generate,
};
